<template>
	<div>
		<div class="groupFieldWrapper">
			<div class="groupFieldWrapper_title">Contract info</div>
			<div class="groupField_wrap">
				<field
						margin="0 10px 0 0"
						width="170px"
						type="text"
						label="Contract start date"
						placeholder="Enter date"
						:dateValue="date_start"
						@updateDate="onDate($event, '')"
						is-date
						is-readonly
				></field>
				<field
						margin="0 10px 0 0"
						width="170px"
						type="text"
						label="Contract end date"
						placeholder="Enter date"
						:dateValue="date_end"
						is-date
						is-readonly
				></field>
				<field
						margin="0 10px 0 0"
						width="170px"
						label="Contract ID"
						placeholder="Enter contract ID"
						:setInputValue="id"
				></field>
				<field
						margin="0"
						width="170px"
						label="Contract type"
						placeholder="Select contract type"
						@updateAutocomplete="onAutocomplete($event, 'customer')"
						:autocompleteValue="contactValue"
						:items="driverList"
						:isClearable="false"
						is-disabled
						is-autocomplete
				></field>
			</div>
		</div>
		<div class="groupFieldWrapper">
			<div class="groupFieldWrapper_title">Payment rules</div>
			<div class="groupField_wrap">
				<field
						margin="0 10px 0 0"
						width="170px"
						label="Payment type"
						placeholder="Select payment type"
						@updateAutocomplete="onAutocomplete($event, 'customer')"
						:autocompleteValue="paymentValue"
						:items="getPaymentsTypeList"
						:isClearable="false"
						is-disabled
						is-autocomplete
				></field>
				<field
						margin="0 10px 0 0"
						width="170px"
						type="number"
						label="Payment amount"
						placeholder="0"
						:setInputValue="amount"
						icon="percent"
						@updateInput="onInput($event, 'amount')"
						is-readonly
				></field>
				<field
						margin="0 10px 0 0"
						width="170px"
						type="number"
						label="Minimum distance"
						placeholder="0"
						icon="mi"
						:setInputValue="min_distance"
						@updateInput="onInput($event, 'min_distance')"
						is-readonly
				></field>
				<field
						margin="0 10px 0 0"
						width="170px"
						type="number"
						label="Extra-stop rate"
						placeholder="0"
						icon="dollar"
						:setInputValue="extra_stop_rate"
						@updateInput="onInput($event, 'extra_stop_rate')"
						is-readonly
				></field>
			</div>
			<div class="groupField_wrap">
				<field
						margin="0 10px 0 0"
						width="170px"
						type="number"
						label="Layover per hour rate"
						placeholder="0"
						icon="dollar"
						:setInputValue="layover_rate"
						@updateInput="onInput($event, 'layover_rate')"
						is-readonly
				></field>
				<field
						margin="0 10px 0 0"
						width="170px"
						type="number"
						label="Detention per hour rate"
						placeholder="0"
						icon="dollar"
						:setInputValue="detention_rate"
						@updateInput="onInput($event, 'detention_rate')"
						is-readonly
				></field>
				<field
						margin="0 10px 0 0"
						width="170px"
						type="number"
						label="TARP rate"
						placeholder="0"
						icon="dollar"
						:setInputValue="tarp_rate"
						@updateInput="onInput($event, 'tarp_rate')"
						is-readonly
				></field>
			</div>
		</div>
		<div class="groupFieldWrapper">
			<div class="groupFieldWrapper_title">Driver company info</div>
			<div class="groupField_wrap">
				<field
						margin="0 10px 0 0"
						width="350px"
						label="Company name"
						placeholder="Enter company name"
						:setInputValue="driver_company"
						@updateInput="onInput($event, 'driver_company')"
						is-readonly
				></field>
				<field
						margin="0 10px 0 0"
						width="350px"
						label="Address"
						placeholder="Enter address"
						:setInputValue="address"
						@updateInput="onInput($event, 'address')"
						is-readonly
				></field>
				<field
						margin="0 10px 0 0"
						width="170px"
						type="number"
						label="Fein #"
						placeholder="Enter Fein"
						:setInputValue="fein"
						@updateInput="onInput($event, 'amount')"
						is-readonly
				></field>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "SalaryContact",
	props: {
		contact: Object,
		driverList: Array,
	},
	computed: {
		...mapGetters([ 'driversList' ]),
		getPaymentsTypeList() {
			return this.driversList.payment_type;
		}
	},
	data: () => ({
		date_start: '',
		date_end: '',
		create_at: '',
		address: '',
		driver_company: '',
		paymentValue: null,
		contactValue: null,
		id: null,
		amount: 0,
		extra_stop_rate: 0,
		layover_rate: 0,
		detention_rate: 0,
		tarp_rate: 0,
		min_distance: 0,
		fein: 0
	}),
	methods: {
		onAutocomplete({ value }, key) {
			console.info('%c autocomplete', 'color: #FFB02E', value, key);
		},
		onInput({ value }, key) {
			this.$emit('updateSafetyRate', +value, key);
		},
	},
	mounted() {
		const {
			contract_type,
			date_start,
			date_end,
			id,
			payment_type,
			amount,
			min_distance,
			extra_stop_rate,
			layover_rate,
			detention_rate,
			tarp_rate,
			driver_company,
			address,
			fein
		} = this.contact || {};
		this.date_end = date_end;
		this.date_start = date_start;
		this.id = id;
		this.amount = amount;
		this.min_distance = min_distance;
		this.extra_stop_rate = extra_stop_rate;
		this.layover_rate = layover_rate;
		this.driver_company = driver_company;
		this.detention_rate = detention_rate;
		this.tarp_rate = tarp_rate;
		this.address = address;
		this.fein = fein;
		this.contactValue = this.driverList.find(item => item.id === contract_type) || {};
		this.paymentValue = this.getPaymentsTypeList.find(item => item.id === payment_type) || {};
	}
};
</script>

<style scoped lang="scss">

</style>
